module.exports = __webpack_public_path__ + "af80e01be6337ac7a423004f14e7fc5a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/EE.svg
// module id = f2F6
// module chunks = 0